import { call } from './call';
import { IS_IOS } from '../constants';
export var push = function () { };
export var pop = function () {
    return call('SKPage', 'pop');
};
export var schema = function (value) {
    var params = value;
    if (IS_IOS)
        params = { schema: value };
    return call('SKNavigation', 'dispatch', params);
};
export var openURL = function (url) {
    var params = { url: url };
    return call('SKNavigation', 'openURL', params);
};
